import styles from './ToolCodeBlock.module.css'
import {type PropsWithChildren, useId, useState, useEffect} from 'react'

export interface ToolCodeBlockProps {
  language?: string
  shellLoading?: boolean
  code: string
  startOffset: number
  endOffset: number
}

export function ToolCodeBlock({shellLoading, children}: PropsWithChildren<ToolCodeBlockProps>) {
  const codeBlockLabelId = useId()
  const [loaderChar, setLoaderChar] = useState('|')

  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined
    if (shellLoading) {
      const loaderChars = ['|', '/', '-', '\\']
      let currentCharIndex = 0
      intervalId = setInterval(() => {
        currentCharIndex = (currentCharIndex + 1) % loaderChars.length
        setLoaderChar(loaderChars[currentCharIndex] || '|')
      }, 250)
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoaderChar('|') // Reset loader char when not loading
    }
    return () => clearInterval(intervalId)
  }, [shellLoading])

  return (
    <figure className={styles.container} aria-labelledby={codeBlockLabelId}>
      <div className={styles.codeContainer}>
        {/* tabIndex={0} for keyboard scrolling; no role="region" — would trip axe landmark-unique when multiple blocks render. */}
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <pre className={styles.code} tabIndex={0}>
          <code className={styles.codeWrap}>
            {children}
            {shellLoading && <span>{loaderChar}</span>}
          </code>
        </pre>
      </div>
    </figure>
  )
}
